import React from "react";
import {
  FaGithub,
  FaHackerrank,
  FaLinkedinIn,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <div>
        <footer className="footer text-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-5 mb-lg-0">
                <h4 className="text-uppercase mb-4">Location</h4>
                <p className="lead mb-0">
                  Ahmedabad
                  <br />
                  380051, Ahmedabad, Uttar Pradesh
                </p>
              </div>
              <div className="col-lg-4 mb-5 mb-lg-0">
                <h4 className="text-uppercase mb-4">Around the Web</h4>
                <a
                  className="btn btn-outline-light btn-social mx-1"
                  href="https://github.com/Ravi13june"
                  target="_blank"
                >
                  <i>
                    <FaGithub size="30px" color="#171515" />
                  </i>
                </a>
                <a
                  className="btn btn-outline-light btn-social mx-1"
                  href="https://www.hackerrank.com/ravi_june13"
                  target="_blank"
                >
                  <i>
                    <FaHackerrank size="30px" color="#068932" />
                  </i>
                </a>
                <a
                  className="btn btn-outline-light btn-social mx-1"
                  href="https://www.linkedin.com/in/ravi-kishan-664842166/"
                  target="_blank"
                >
                  <i>
                    <FaLinkedinIn size="30px" color="#0072b1" />
                  </i>
                </a>
                <a
                  className="btn btn-outline-light btn-social mx-1"
                  href="https://www.instagram.com/ravi_june13/"
                  target="_blank"
                >
                  <i>
                    <FaInstagram size="30px" color="#bc2a8d" />
                  </i>
                </a>
                <a
                  className="btn btn-outline-light btn-social mx-1"
                  href="https://twitter.com/ravi_13june"
                  target="_blank"
                >
                  <i>
                    <FaTwitter size="30px" color="#0072b1" />
                  </i>
                </a>
              </div>
              <div className="col-lg-4">
                <h4 className="text-uppercase mb-4">About Portfolio</h4>
                <p className="lead mb-0">
                  This Portfolio built with ReactJS and JSX, and created by
                  Ravi.
                </p>
              </div>
            </div>
          </div>
        </footer>
        <div className="copyright py-4 text-center text-white">
          <div className="container">
            <small>All CopyRight © Reserve {new Date().getFullYear()}</small>
          </div>
        </div>
      </div>
      <footer id="copyright">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <p
                class="wow bounceIn"
                data-wow-offset="50"
                data-wow-delay="0.3s"
              >
                Copyright &copy; Reserve {new Date().getFullYear()}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
